import { FormControlLabel, Paper, Switch } from '@mui/material';
import { t } from 'i18next';

type Props = {
  initialLoad: boolean;
  disabled: boolean;
  value: boolean;
  onChange: (checked: boolean) => void;
};

export const FilterToggle = ({ initialLoad, value, disabled, onChange }: Props) => {
  if (initialLoad) {
    return null;
  }

  return (
    <Paper elevation={2} sx={{ minHeight: '4rem', px: 2, display: 'flex' }} className="issues-filter-toggle">
      <FormControlLabel
        disabled={disabled}
        control={<Switch checked={value} onChange={(_, checked) => onChange(checked)} />}
        label={t('includeFilteredIssues')}
      />
    </Paper>
  );
};
